module.exports = __webpack_public_path__ + "img/KW_lip.4e2afdb6.png";